import { render, staticRenderFns } from "./form-checkbox.vue?vue&type=template&id=84e6dfd2"
import script from "./form-checkbox.vue?vue&type=script&lang=js"
export * from "./form-checkbox.vue?vue&type=script&lang=js"
import style0 from "./form-checkbox.vue?vue&type=style&index=0&id=84e6dfd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports